module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAOCAYAAAAbvf3sAAAAS0lEQVQoFZXBsRHAQAyAMNh/aIfCtXMvySN5JGvCwRBZEw6GyJoQw0HWhBgOsiYcDJE14WCI/JgQQ+THhBgia8LBEFkTDobII3n0AR6AKA8PfsWZAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/flappybird/number_context_05.png
// module id = 227
// module chunks = 0